export default "__VITE_ASSET__BjuZz1Jq__"